module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/paginator/paginator.component.scss
// module id = ./src/app/shared-components/paginator/paginator.component.scss
// module chunks = main